import { Component } from '@angular/core'
import { LogEvent } from 'src/app/interfaces/log'
import { GeneralService } from 'src/app/services/general/general.service'
import { LogService } from 'src/app/services/log/log.service'
import { ModalService } from 'src/app/services/modal/modal.service'

@Component({
  selector: 'app-root',
  templateUrl: './coupang-ad-modal.component.html',
  styleUrls: ['./coupang-ad-modal.component.scss'],
})
export class CoupangAdModalComponent {
  constructor(
    private generalService: GeneralService,
    private modalService: ModalService,
    private logService: LogService
  ) {}

  ngOnInit(): void {
    this.logService.eventLogging(LogEvent.COUPANG_AD_MODAL_VIEWED)
  }

  onClickNavigateToCoupang(): void {
    this.logService.eventLogging(LogEvent.COUPANG_AD_MODAL_OPEN_BUTTON_CLICKED)
    this.generalService.openInappBrowser('https://link.coupang.com/a/69UhD')
    this.modalService.dismiss()
    this.generalService.setCoupangModalClickedDt()
  }
}
